import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      'app.name': 'Eyvo eProcurement',
      'nav.dashboard': 'Dashboard',
      'nav.dataFiles': 'Data Files',
      'nav.categories': 'Category Code',
      'nav.currencies': 'Currency Code',
      'nav.deliveryPoints': 'Delivery Point',
      'nav.documentTypes': 'Document Type',
      'nav.invoicePoints': 'Invoice Point',
      'nav.items': 'Items',
      'nav.suppliers': 'Supplier',
      'nav.contracts': 'Supplier Contracts',
      'nav.terms': 'Terms & Conditions',
      'nav.accountCodes': 'Account Codes',
      'nav.requests': 'Requisitions',
      'nav.orders': 'Purchase Orders',
      'nav.rfq': 'RFx Sourcing',
      'nav.approvals': 'Approvals',
      'nav.assetRegister': 'Asset Register',
      'nav.invoiceMatching': 'Invoice Matching',
      'nav.inventory': 'Inventory Control',
      'nav.goodsReceived': 'Receiving',
      'nav.recipe': 'Recipe',
      'nav.expenses': 'Expense Management',
      'nav.users': 'User Maintenance',
      'nav.auditLogs': 'Audit Logs',
      'common.save': 'Save',
      'common.delete': 'Delete',
      'common.cancel': 'Cancel',
      'common.addNew': '+ Add New',
      'common.export': 'Export',
      'common.search': 'Search',
      'common.clear': 'Clear',
      'common.active': 'Active',
      'common.inactive': 'Inactive',
      'common.yes': 'Yes',
      'common.no': 'No',
      'common.loading': 'Loading...',
      'common.noRecords': 'No records found',
      'common.totalRecords': 'Total records: {{count}}',
      'common.page': 'Page {{current}} of {{total}}',
      'term.colour': 'Colour',
      'term.colourTheme': 'Colour Theme',
      'term.colourThemeDesc': 'Choose a colour theme that suits your preference. This changes the sidebar, accents, and buttons across the entire application.',
      'term.organisation': 'organization',
      'term.Organisation': 'Organization',
      'term.licence': 'License',
      'term.licences': 'Licenses',
      'term.licenceInfo': 'License Information',
      'term.userLicenceLimit': 'User License Limit',
      'term.licenceManagedMsg': 'License limits and active modules are managed by Eyvo. Contact <strong>support@eyvo.com</strong> to add licenses or unlock additional modules.',
      'term.customise': 'Customize',
      'term.customiseDashboard': 'Customize Dashboard',
      'term.customiseHint': 'click Customize to personalize',
      'term.authorised': 'authorized',
      'term.unauthorised': 'Unauthorized',
      'term.authorisation': 'authorization',
      'term.favourite': 'favorite',
      'term.favourites': 'favorites',
      'term.addFavourite': 'Add to favorites',
      'term.removeFavourite': 'Remove from favorites',
      'term.softwareLicence': 'Software License',
      'term.findOrganisation': 'Find Your Organization',
      'term.companyCodeHint': 'Your company code was provided when your organization signed up.',
      'term.creatingOrganisation': 'Creating your organization...',
      'term.tellUsOrganisation': 'Tell us about your organization',
      'term.configureSettings': 'Configure system-wide settings for <strong>{{name}}</strong>',
      'term.changesApplyOrg': 'Changes made here apply to your organization only and do not affect other clients.',
      'term.organisationSize': 'Organization Size',
      'term.costCentre': 'Cost Centre',
      'term.costCentres': 'cost centres',
      'term.restrictedMsg': 'Restricted to authorised Eyvo staff only',
      'term.unauthorisedMsg': 'Unauthorised access attempts are logged and monitored.',
      'term.modulesLicences': 'Modules & Licences',
      'term.licenceAgreement': 'Licence Agreement',
      'profile.personalInfo': 'Personal Information',
      'profile.firstName': 'First Name',
      'profile.lastName': 'Last Name',
      'profile.jobTitle': 'Job Title',
      'profile.extension': 'Extension',
      'profile.telephone': 'Telephone',
      'profile.mobile': 'Mobile',
      'profile.saveProfile': 'Save Profile',
      'profile.saving': 'Saving...',
      'profile.languagePref': 'Language Preference',
      'profile.languageDesc': 'Choose the language you want the interface to display in. This applies immediately and is saved to your profile.',
      'profile.currentLang': 'Current',
      'profile.saveLanguage': 'Save Language',
      'profile.changePassword': 'Change Password',
      'profile.currentPassword': 'Current Password',
      'profile.newPassword': 'New Password',
      'profile.confirmPassword': 'Confirm New Password',
      'profile.passwordHint': 'Must contain: uppercase, lowercase, number, and special character (!@#$%^&*)',
      'profile.minChars': 'Minimum 8 characters',
      'profile.accountInfo': 'Account Information',
    }
  },
  'en-US': {
    translation: {
      'app.name': 'Eyvo eProcurement',
      'nav.dashboard': 'Dashboard',
      'nav.dataFiles': 'Data Files',
      'nav.categories': 'Category Code',
      'nav.currencies': 'Currency Code',
      'nav.deliveryPoints': 'Delivery Point',
      'nav.documentTypes': 'Document Type',
      'nav.invoicePoints': 'Invoice Point',
      'nav.items': 'Items',
      'nav.suppliers': 'Supplier',
      'nav.contracts': 'Supplier Contracts',
      'nav.terms': 'Terms & Conditions',
      'nav.accountCodes': 'Account Codes',
      'nav.requests': 'Requisitions',
      'nav.orders': 'Purchase Orders',
      'nav.rfq': 'RFx Sourcing',
      'nav.approvals': 'Approvals',
      'nav.assetRegister': 'Asset Register',
      'nav.invoiceMatching': 'Invoice Matching',
      'nav.inventory': 'Inventory Control',
      'nav.goodsReceived': 'Receiving',
      'nav.recipe': 'Recipe',
      'nav.expenses': 'Expense Management',
      'nav.users': 'User Maintenance',
      'nav.auditLogs': 'Audit Logs',
      'common.save': 'Save',
      'common.delete': 'Delete',
      'common.cancel': 'Cancel',
      'common.addNew': '+ Add New',
      'common.export': 'Export',
      'common.search': 'Search',
      'common.clear': 'Clear',
      'common.active': 'Active',
      'common.inactive': 'Inactive',
      'common.yes': 'Yes',
      'common.no': 'No',
      'common.loading': 'Loading...',
      'common.noRecords': 'No records found',
      'common.totalRecords': 'Total records: {{count}}',
      'common.page': 'Page {{current}} of {{total}}',
      'term.colour': 'Color',
      'term.colourTheme': 'Color Theme',
      'term.colourThemeDesc': 'Choose a color theme that suits your preference. This changes the sidebar, accents, and buttons across the entire application.',
      'term.organisation': 'organization',
      'term.Organisation': 'Organization',
      'term.licence': 'License',
      'term.licences': 'Licenses',
      'term.licenceInfo': 'License Information',
      'term.userLicenceLimit': 'User License Limit',
      'term.licenceManagedMsg': 'License limits and active modules are managed by Eyvo. Contact <strong>support@eyvo.com</strong> to add licenses or unlock additional modules.',
      'term.customise': 'Customize',
      'term.customiseDashboard': 'Customize Dashboard',
      'term.customiseHint': 'click Customize to personalize',
      'term.authorised': 'authorized',
      'term.unauthorised': 'Unauthorized',
      'term.authorisation': 'authorization',
      'term.favourite': 'favorite',
      'term.favourites': 'favorites',
      'term.addFavourite': 'Add to favorites',
      'term.removeFavourite': 'Remove from favorites',
      'term.softwareLicence': 'Software License',
      'term.findOrganisation': 'Find Your Organization',
      'term.companyCodeHint': 'Your company code was provided when your organization signed up.',
      'term.creatingOrganisation': 'Creating your organization...',
      'term.tellUsOrganisation': 'Tell us about your organization',
      'term.configureSettings': 'Configure system-wide settings for <strong>{{name}}</strong>',
      'term.changesApplyOrg': 'Changes made here apply to your organization only and do not affect other clients.',
      'term.organisationSize': 'Organization Size',
      'term.costCentre': 'Cost Center',
      'term.costCentres': 'cost centers',
      'term.restrictedMsg': 'Restricted to authorized Eyvo staff only',
      'term.unauthorisedMsg': 'Unauthorized access attempts are logged and monitored.',
      'term.modulesLicences': 'Modules & Licenses',
      'term.licenceAgreement': 'License Agreement',
      'profile.personalInfo': 'Personal Information',
      'profile.firstName': 'First Name',
      'profile.lastName': 'Last Name',
      'profile.jobTitle': 'Job Title',
      'profile.extension': 'Extension',
      'profile.telephone': 'Telephone',
      'profile.mobile': 'Mobile',
      'profile.saveProfile': 'Save Profile',
      'profile.saving': 'Saving...',
      'profile.languagePref': 'Language Preference',
      'profile.languageDesc': 'Choose the language you want the interface to display in. This applies immediately and is saved to your profile.',
      'profile.currentLang': 'Current',
      'profile.saveLanguage': 'Save Language',
      'profile.changePassword': 'Change Password',
      'profile.currentPassword': 'Current Password',
      'profile.newPassword': 'New Password',
      'profile.confirmPassword': 'Confirm New Password',
      'profile.passwordHint': 'Must contain: uppercase, lowercase, number, and special character (!@#$%^&*)',
      'profile.minChars': 'Minimum 8 characters',
      'profile.accountInfo': 'Account Information',
    }
  },
  fr: {
    translation: {
      'app.name': 'Eyvo eProcurement',
      'nav.dashboard': 'Tableau de bord',
      'nav.dataFiles': 'Fichiers de données',
      'nav.categories': 'Code de catégorie',
      'nav.currencies': 'Code de devise',
      'nav.deliveryPoints': 'Point de livraison',
      'nav.documentTypes': 'Type de document',
      'nav.invoicePoints': 'Point de facturation',
      'nav.items': 'Articles',
      'nav.suppliers': 'Fournisseur',
      'nav.contracts': 'Contrats fournisseurs',
      'nav.terms': 'Termes & Conditions',
      'nav.accountCodes': 'Codes comptables',
      'nav.requests': 'Réquisitions',
      'nav.orders': 'Bons de Commande',
      'nav.rfq': 'RFx Sourcing',
      'nav.approvals': 'Approbations',
      'nav.assetRegister': 'Registre des actifs',
      'nav.invoiceMatching': 'Rapprochement des factures',
      'nav.inventory': 'Contrôle des stocks',
      'nav.goodsReceived': 'Marchandises reçues',
      'nav.recipe': 'Recette',
      'nav.expenses': 'Gestion des dépenses',
      'common.save': 'Enregistrer',
      'common.delete': 'Supprimer',
      'common.cancel': 'Annuler',
      'common.addNew': '+ Ajouter',
      'common.search': 'Rechercher',
      'common.active': 'Actif',
      'term.colourTheme': 'Thème de couleurs',
      'term.colourThemeDesc': 'Choisissez un thème de couleurs selon vos préférences. Cela modifie la barre latérale, les accents et les boutons dans toute l\'application.',
      'term.customise': 'Personnaliser',
      'term.customiseDashboard': 'Personnaliser le tableau de bord',
      'term.softwareLicence': 'Licence logicielle',
      'term.findOrganisation': 'Trouvez votre organisation',
      'term.companyCodeHint': 'Votre code entreprise vous a été fourni lors de l\'inscription de votre organisation.',
      'term.addFavourite': 'Ajouter aux favoris',
      'term.removeFavourite': 'Retirer des favoris',
      'profile.personalInfo': 'Informations personnelles',
      'profile.firstName': 'Prénom',
      'profile.lastName': 'Nom de famille',
      'profile.jobTitle': 'Titre du poste',
      'profile.extension': 'Extension',
      'profile.telephone': 'Téléphone',
      'profile.mobile': 'Portable',
      'profile.saveProfile': 'Enregistrer le profil',
      'profile.saving': 'Enregistrement...',
      'profile.languagePref': 'Préférence de langue',
      'profile.languageDesc': 'Choisissez la langue dans laquelle vous souhaitez afficher l\'interface. Elle s\'applique immédiatement et est enregistrée dans votre profil.',
      'profile.currentLang': 'Actuel',
      'profile.saveLanguage': 'Enregistrer la langue',
      'profile.changePassword': 'Changer le mot de passe',
      'profile.currentPassword': 'Mot de passe actuel',
      'profile.newPassword': 'Nouveau mot de passe',
      'profile.confirmPassword': 'Confirmer le nouveau mot de passe',
      'profile.passwordHint': 'Doit contenir : majuscule, minuscule, chiffre et caractère spécial (!@#$%^&*)',
      'profile.minChars': 'Minimum 8 caractères',
      'profile.accountInfo': 'Informations du compte',
    }
  },
  de: {
    translation: {
      'app.name': 'Eyvo eProcurement',
      'nav.dashboard': 'Dashboard',
      'nav.dataFiles': 'Stammdaten',
      'nav.categories': 'Kategorien',
      'nav.currencies': 'Währungen',
      'nav.deliveryPoints': 'Lieferstellen',
      'nav.documentTypes': 'Dokumenttypen',
      'nav.invoicePoints': 'Rechnungsstellen',
      'nav.items': 'Artikel',
      'nav.suppliers': 'Lieferant',
      'nav.contracts': 'Lieferantenverträge',
      'nav.terms': 'AGB',
      'nav.accountCodes': 'Kontocodes',
      'nav.requests': 'Bestellanforderungen',
      'nav.orders': 'Bestellungen',
      'nav.rfq': 'Angebotsanfragen',
      'nav.approvals': 'Genehmigungen',
      'nav.assetRegister': 'Anlagenverzeichnis',
      'nav.invoiceMatching': 'Rechnungsabgleich',
      'nav.inventory': 'Bestandskontrolle',
      'nav.goodsReceived': 'Wareneingang',
      'nav.recipe': 'Stückliste',
      'nav.expenses': 'Spesenmanagement',
      'common.save': 'Speichern',
      'common.delete': 'Löschen',
      'common.cancel': 'Abbrechen',
      'common.addNew': '+ Neu',
      'common.search': 'Suchen',
      'common.active': 'Aktiv',
      'term.colourTheme': 'Farbthema',
      'term.colourThemeDesc': 'Wählen Sie ein Farbthema nach Ihren Wünschen. Dies ändert die Seitenleiste, Akzente und Schaltflächen in der gesamten Anwendung.',
      'term.customise': 'Anpassen',
      'term.customiseDashboard': 'Dashboard anpassen',
      'term.softwareLicence': 'Softwarelizenz',
      'term.findOrganisation': 'Finden Sie Ihre Organisation',
      'term.companyCodeHint': 'Ihr Firmencode wurde Ihnen bei der Anmeldung Ihrer Organisation mitgeteilt.',
      'term.addFavourite': 'Zu Favoriten hinzufügen',
      'term.removeFavourite': 'Aus Favoriten entfernen',
      'profile.personalInfo': 'Persönliche Informationen',
      'profile.firstName': 'Vorname',
      'profile.lastName': 'Nachname',
      'profile.jobTitle': 'Berufsbezeichnung',
      'profile.extension': 'Durchwahl',
      'profile.telephone': 'Telefon',
      'profile.mobile': 'Mobil',
      'profile.saveProfile': 'Profil speichern',
      'profile.saving': 'Speichern...',
      'profile.languagePref': 'Spracheinstellung',
      'profile.languageDesc': 'Wählen Sie die Sprache für die Benutzeroberfläche. Die Änderung wird sofort übernommen und in Ihrem Profil gespeichert.',
      'profile.currentLang': 'Aktuell',
      'profile.saveLanguage': 'Sprache speichern',
      'profile.changePassword': 'Passwort ändern',
      'profile.currentPassword': 'Aktuelles Passwort',
      'profile.newPassword': 'Neues Passwort',
      'profile.confirmPassword': 'Neues Passwort bestätigen',
      'profile.passwordHint': 'Muss enthalten: Großbuchstabe, Kleinbuchstabe, Zahl und Sonderzeichen (!@#$%^&*)',
      'profile.minChars': 'Mindestens 8 Zeichen',
      'profile.accountInfo': 'Kontoinformationen',
    }
  },
  es: {
    translation: {
      'app.name': 'Eyvo eProcurement',
      'nav.dashboard': 'Panel principal',
      'nav.dataFiles': 'Archivos de datos',
      'nav.categories': 'Categorías',
      'nav.currencies': 'Monedas',
      'nav.deliveryPoints': 'Puntos de entrega',
      'nav.documentTypes': 'Tipos de documento',
      'nav.invoicePoints': 'Puntos de facturación',
      'nav.items': 'Artículos',
      'nav.suppliers': 'Proveedor',
      'nav.contracts': 'Contratos de proveedores',
      'nav.terms': 'Términos y Condiciones',
      'nav.accountCodes': 'Códigos contables',
      'nav.requests': 'Requisiciones',
      'nav.orders': 'Órdenes de compra',
      'nav.rfq': 'Solicitud de cotización',
      'nav.approvals': 'Aprobaciones',
      'nav.assetRegister': 'Registro de activos',
      'nav.invoiceMatching': 'Conciliación de facturas',
      'nav.inventory': 'Control de inventario',
      'nav.goodsReceived': 'Mercancías recibidas',
      'nav.recipe': 'Lista de materiales',
      'nav.expenses': 'Gestión de gastos',
      'common.save': 'Guardar',
      'common.delete': 'Eliminar',
      'common.cancel': 'Cancelar',
      'common.addNew': '+ Nuevo',
      'common.search': 'Buscar',
      'common.active': 'Activo',
      'term.colourTheme': 'Tema de colores',
      'term.colourThemeDesc': 'Elija un tema de colores según sus preferencias. Esto cambia la barra lateral, los acentos y los botones en toda la aplicación.',
      'term.customise': 'Personalizar',
      'term.customiseDashboard': 'Personalizar panel',
      'term.softwareLicence': 'Licencia de software',
      'term.findOrganisation': 'Encuentre su organización',
      'term.companyCodeHint': 'Su código de empresa fue proporcionado cuando su organización se registró.',
      'term.addFavourite': 'Añadir a favoritos',
      'term.removeFavourite': 'Quitar de favoritos',
      'profile.personalInfo': 'Información personal',
      'profile.firstName': 'Nombre',
      'profile.lastName': 'Apellido',
      'profile.jobTitle': 'Cargo',
      'profile.extension': 'Extensión',
      'profile.telephone': 'Teléfono',
      'profile.mobile': 'Móvil',
      'profile.saveProfile': 'Guardar perfil',
      'profile.saving': 'Guardando...',
      'profile.languagePref': 'Preferencia de idioma',
      'profile.languageDesc': 'Elija el idioma en el que desea mostrar la interfaz. Se aplica de inmediato y se guarda en su perfil.',
      'profile.currentLang': 'Actual',
      'profile.saveLanguage': 'Guardar idioma',
      'profile.changePassword': 'Cambiar contraseña',
      'profile.currentPassword': 'Contraseña actual',
      'profile.newPassword': 'Nueva contraseña',
      'profile.confirmPassword': 'Confirmar nueva contraseña',
      'profile.passwordHint': 'Debe contener: mayúscula, minúscula, número y carácter especial (!@#$%^&*)',
      'profile.minChars': 'Mínimo 8 caracteres',
      'profile.accountInfo': 'Información de la cuenta',
    }
  },
  ar: {
    translation: {
      'app.name': 'Eyvo eProcurement',
      'nav.dashboard': 'لوحة التحكم',
      'nav.dataFiles': 'ملفات البيانات',
      'nav.categories': 'رموز التصنيف',
      'nav.currencies': 'رموز العملات',
      'nav.deliveryPoints': 'نقاط التسليم',
      'nav.documentTypes': 'أنواع المستندات',
      'nav.invoicePoints': 'نقاط الفوترة',
      'nav.items': 'الأصناف',
      'nav.suppliers': 'المورد',
      'nav.contracts': 'عقود الموردين',
      'nav.terms': 'الشروط والأحكام',
      'nav.accountCodes': 'رموز الحسابات',
      'nav.requests': 'طلبات الشراء',
      'nav.orders': 'أوامر الشراء',
      'nav.rfq': 'طلب عرض أسعار',
      'nav.approvals': 'الموافقات',
      'nav.assetRegister': 'سجل الأصول',
      'nav.invoiceMatching': 'مطابقة الفواتير',
      'nav.inventory': 'مراقبة المخزون',
      'nav.goodsReceived': 'البضائع المستلمة',
      'nav.recipe': 'قائمة المواد',
      'nav.expenses': 'إدارة المصروفات',
      'common.save': 'حفظ',
      'common.delete': 'حذف',
      'common.cancel': 'إلغاء',
      'common.addNew': '+ جديد',
      'common.search': 'بحث',
      'common.active': 'نشط',
      'term.colourTheme': 'سمة الألوان',
      'term.colourThemeDesc': 'اختر سمة ألوان تناسب تفضيلاتك. هذا يغير الشريط الجانبي والتمييزات والأزرار في جميع أنحاء التطبيق.',
      'term.customise': 'تخصيص',
      'term.customiseDashboard': 'تخصيص لوحة التحكم',
      'term.softwareLicence': 'ترخيص البرنامج',
      'term.findOrganisation': 'ابحث عن مؤسستك',
      'term.companyCodeHint': 'تم تقديم رمز شركتك عند تسجيل مؤسستك.',
      'term.addFavourite': 'إضافة إلى المفضلة',
      'term.removeFavourite': 'إزالة من المفضلة',
      'profile.personalInfo': 'المعلومات الشخصية',
      'profile.firstName': 'الاسم الأول',
      'profile.lastName': 'اسم العائلة',
      'profile.jobTitle': 'المسمى الوظيفي',
      'profile.extension': 'التحويلة',
      'profile.telephone': 'الهاتف',
      'profile.mobile': 'الجوال',
      'profile.saveProfile': 'حفظ الملف الشخصي',
      'profile.saving': 'جاري الحفظ...',
      'profile.languagePref': 'تفضيل اللغة',
      'profile.languageDesc': 'اختر اللغة التي تريد عرض الواجهة بها. يتم تطبيقها فوراً وحفظها في ملفك الشخصي.',
      'profile.currentLang': 'الحالية',
      'profile.saveLanguage': 'حفظ اللغة',
      'profile.changePassword': 'تغيير كلمة المرور',
      'profile.currentPassword': 'كلمة المرور الحالية',
      'profile.newPassword': 'كلمة المرور الجديدة',
      'profile.confirmPassword': 'تأكيد كلمة المرور الجديدة',
      'profile.passwordHint': 'يجب أن تحتوي على: حرف كبير، حرف صغير، رقم وحرف خاص (!@#$%^&*)',
      'profile.minChars': '٨ أحرف على الأقل',
      'profile.accountInfo': 'معلومات الحساب',
    }
  },
  ja: {
    translation: {
      'app.name': 'Eyvo eProcurement',
      'nav.dashboard': 'ダッシュボード',
      'nav.dataFiles': 'データファイル',
      'nav.categories': 'カテゴリコード',
      'nav.currencies': '通貨コード',
      'nav.deliveryPoints': '配送先',
      'nav.documentTypes': 'ドキュメントタイプ',
      'nav.invoicePoints': '請求先',
      'nav.items': 'アイテム',
      'nav.suppliers': 'サプライヤー',
      'nav.contracts': 'サプライヤー契約',
      'nav.terms': '利用規約',
      'nav.accountCodes': '勘定科目コード',
      'nav.requests': '購買依頼',
      'nav.orders': '発注書',
      'nav.rfq': '見積依頼',
      'nav.approvals': '承認',
      'nav.assetRegister': '資産台帳',
      'nav.invoiceMatching': '請求書照合',
      'nav.inventory': '在庫管理',
      'nav.goodsReceived': '入荷',
      'nav.recipe': '部品表',
      'nav.expenses': '経費管理',
      'common.save': '保存',
      'common.delete': '削除',
      'common.cancel': 'キャンセル',
      'common.addNew': '+ 新規',
      'common.search': '検索',
      'common.active': '有効',
      'term.colourTheme': 'カラーテーマ',
      'term.colourThemeDesc': 'お好みのカラーテーマを選択してください。サイドバー、アクセント、ボタンがアプリケーション全体で変更されます。',
      'term.customise': 'カスタマイズ',
      'term.customiseDashboard': 'ダッシュボードをカスタマイズ',
      'term.softwareLicence': 'ソフトウェアライセンス',
      'term.findOrganisation': '組織を検索',
      'term.companyCodeHint': '会社コードは組織の登録時に提供されました。',
      'term.addFavourite': 'お気に入りに追加',
      'term.removeFavourite': 'お気に入りから削除',
      'profile.personalInfo': '個人情報',
      'profile.firstName': '名',
      'profile.lastName': '姓',
      'profile.jobTitle': '役職',
      'profile.extension': '内線番号',
      'profile.telephone': '電話番号',
      'profile.mobile': '携帯電話',
      'profile.saveProfile': 'プロフィールを保存',
      'profile.saving': '保存中...',
      'profile.languagePref': '言語設定',
      'profile.languageDesc': 'インターフェースの表示言語を選択してください。即座に適用され、プロフィールに保存されます。',
      'profile.currentLang': '現在',
      'profile.saveLanguage': '言語を保存',
      'profile.changePassword': 'パスワード変更',
      'profile.currentPassword': '現在のパスワード',
      'profile.newPassword': '新しいパスワード',
      'profile.confirmPassword': '新しいパスワードの確認',
      'profile.passwordHint': '大文字、小文字、数字、特殊文字 (!@#$%^&*) を含む必要があります',
      'profile.minChars': '8文字以上',
      'profile.accountInfo': 'アカウント情報',
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    detection: { order: ['localStorage', 'navigator'] }
  });

export default i18n;
